import { render, staticRenderFns } from "./WVcard.vue?vue&type=template&id=3baa6c69&"
import script from "./WVcard.vue?vue&type=script&lang=js&"
export * from "./WVcard.vue?vue&type=script&lang=js&"
import style0 from "./WVcard.vue?vue&type=style&index=0&id=3baa6c69&prod&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports